import styled from "styled-components";

export const PreviewWrapper = styled.div`
  width: 620px;
  height: 876px;
  border-radius: 20px;
  background: #f0f3f8;

  padding: 16px 20px;

  display: flex;
  align-items: center;
  justify-content: center;

  > span {
    color: #444;
    text-align: center;
    font-family: Pretendard;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;
